import React from "react";
import ReactECharts from "echarts-for-react";

const LineChart = ({ data,range,display }) => {
  console.log(data)
  // Ensure the data is properly structured and available
  if (!data || !Array.isArray(data.xData) || !Array.isArray(data.yData)) {
    console.error("Invalid data passed to LineChart:", data);
    return <div>No data available for chart</div>;
  } 

  const options = {
    grid: {
      left: "4%",
      right: "4%",
      top: "10%",
      bottom: "15%",
    },
    tooltip: {
      trigger: "axis",
      backgroundColor: "#fff",
      borderColor: "#ccc",
      borderWidth: 1,
      borderRadius: 8,
      padding: [10, 15],
      textStyle: {
        color: "#333",
        fontSize: 14,
        fontFamily: "Arial, sans-serif",
      },
      formatter: (params) => {
        console.log(params)
        const pointData = params[0];
        const dayIndex = pointData.dataIndex;
        const totalBookings = pointData.value;
        // Do not show tooltip for null values
        if (totalBookings === null || totalBookings === undefined) {
          return "";
        }

        const dayDetails = data.details?.[dayIndex] || {};

        let tooltip = `<div style="font-weight: bold; margin-bottom: 8px;">Bookings - ${totalBookings}</div>`;
        if (Object.keys(dayDetails).length) {
          Object.entries(dayDetails).forEach(([name, count]) => {
            tooltip += `<div style="display: flex; justify-content: space-between;">
              <span>${name} - </span>
              <span>${count}</span>
            </div>`;
          });
        } else {
          tooltip += `<div>No breakdown available</div>`;
        }
        return tooltip;
      },
    },
    xAxis: {
      type: "category",
      data: data.xData, // Use xData from the provided data
      boundaryGap: false,
      axisTick: {
        alignWithLabel: true,
        inside: true,
      },
      axisLabel: {
        fontSize: 14,
        fontWeight: "bold",
        color: "#102A43",
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        fontSize: 14,
        color: "#102A43",
      },
      splitLine: {
        lineStyle: {
          type: "dashed",
          color: "#E0E0E0",
        },
      },
    },
    series: [
      {
        name: "Bookings",
        data: data.yData, // Use yData from the provided data
        type: "line",
        connectNulls: false, // Ensure the line is disconnected for null values
        smooth: true,
        lineStyle: {
          width: 2,
          color: "#85D7FF",
        },
        itemStyle: {
          color: "#102A43",
        },
        symbol: "circle",
        symbolSize: 4,
      },
    ],
    title: {
      show: range === "Quarter"|| range==="LastQuarter", // ✅ Show title only if range is "Quarter"
            text: display, // ✅ Dynamically show selectedRangeDisplay
      left: "center",
      bottom: 0,
      textStyle: {
        fontSize: 14,
        fontWeight: "normal",
        color: "#666",
      },
      backgroundColor: "#fff",
      borderColor: "#ddd",
      borderWidth: 0.5,
      borderRadius: 2,
      padding: [10, 30, 10, 30],
    },
  };

  return (
    <div>
      <ReactECharts option={options} style={{ height: "400px", width: "100%" }} />
    </div>
  );
};

export default LineChart;
